<template>
  <div class="form-box">
    <FormTitle :infoName="infoName" />
    <div class="form-list">
      <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="demo-ruleForm" @submit.native.prevent>
        <el-form-item label="新闻稿主题">
          <el-input v-model="ruleForm.title"
                    type="text"
                    placeholder="请输入新闻稿主题，例如：XX企业智能化技改项目竣工投产仪式顺利举办"
                    maxlength="100"
                    show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="参会人员及活动概况">
            <el-input type="textarea"
              v-model="ruleForm.extParam.detail"
              :rows="4"
              placeholder="描述此次新闻稿主要参会人员及活动概况，例如：董事长代表大湾区全体分支机构致欢迎致辞，副总经理张三出席投产仪式并致开幕词，突出智造升级成果，清晰列明出仪式流程与项目投产带来的企业发展利好。"
              maxlength="300"
              show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="选择模型">
          <el-radio-group v-model="ruleForm.extParam.modelCode">
              <el-radio :label="1">标准版</el-radio>
              <el-radio :label="2">
                专业版
                <el-tooltip class="item" effect="light" content="篇幅更长,研究领域更广,内容更精准" placement="top-start">
                  <i class="el-icon-info" style="color: #ffaa00;"></i>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
        </el-form-item>
      </el-form>

    </div>

    <div class="form-btn">
      <el-checkbox class="form-check" v-model="btnInfo.checked">{{btnInfo.title}}</el-checkbox>
      <el-button style="width: 180px" type="primary" :disabled="!btnInfo.checked" @click="submitForm('ruleForm')">立即创作</el-button>
    </div>

    <NoticeWrapper />
  </div>
</template>

<script>
  import CommonApi from "@/api/common"
  import { orderMixin } from '@/utils/orderMixin'
  import FormTitle from "@/components/FormTitle/index.vue"
  import NoticeWrapper from "@/components/NoticeWrapper/index.vue"
  export default {
    components: {NoticeWrapper, FormTitle},
    mixins: [orderMixin],
    props: ['infoName'],
		data() {
			return {
        ruleForm: {
          title: '',
          creationDocId: 20,
          creationDocCode: 'NEW',
          channelCode: null,
          extParam: {
            version: 1,
            modelCode: 1,
            detail: ''
          }
        },
        // rules: {
        //   title: [
        //     { required: true, message: '请输入书名', trigger: 'blur' }
        //   ],
        // },
        btnInfo: {
          title: '我已阅读并同意: 所有的范文仅用于格式和思路参考',
          checked: true
        },
        paramsData: '', // 储存跳页面的传值
			}
		},
		created() {},
		methods: {
      submitForm(formName) {
        let _this = this

        if(_this.ruleForm.title === ''){
          return _this.$message({
            message: '新闻稿主题',
            type: 'warning',
            duration: 2000,
            customClass: "focus-message",
          });
        }

        _this.paramsData = _this.ruleForm
        let info = JSON.stringify(_this.ruleForm.extParam)
        _this.ruleForm.extParam = info
        //生成订单 mixin
        _this.createOrder(_this.ruleForm,_this.paramsData)

        // _this.$refs[formName].validate((valid) => {
        //   if (valid) {
        //     _this.paramsData = _this.ruleForm
        //     let info = JSON.stringify(_this.ruleForm.extParam)
        //     _this.ruleForm.extParam = info
        //     //生成订单 mixin
        //     _this.createOrder(_this.ruleForm,_this.paramsData)
        //   } else {
        //     return false;
        //   }
        // });
      },
      // resetForm(formName) {
      //   this.$refs[formName].resetFields();
      // }
		}
	}
</script>

<style lang="less" scoped>
@import "@/assets/css/pageContent";
</style>
